// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `hr {
  margin-bottom: 0.5rem !important;
  margin-top: 0.5rem !important;
}

.formatted {
  white-space: pre-wrap;
}

.mat-form-field-table {
  width: 50%;
  height: 80% !important;
}`, "",{"version":3,"sources":["webpack://./projects/zbs-app/src/app/modules/order/components/order-detail/order-detail.component.scss"],"names":[],"mappings":"AAAA;EACI,gCAAA;EACA,6BAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,UAAA;EACA,sBAAA;AACJ","sourcesContent":["hr {\r\n    margin-bottom: 0.5rem !important;\r\n    margin-top: 0.5rem !important;\r\n}\r\n\r\n.formatted {\r\n    white-space: pre-wrap;\r\n}\r\n\r\n.mat-form-field-table {\r\n    width: 50%;\r\n    height: 80% !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
